/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rights_Tools_Drawer_Add_Tool_ButtonInputs */



/**
* | output |
* | --- |
* | "Add tool" |
*
* @param {Rights_Tools_Drawer_Add_Tool_ButtonInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rights_tools_drawer_add_tool_button = /** @type {((inputs?: Rights_Tools_Drawer_Add_Tool_ButtonInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rights_Tools_Drawer_Add_Tool_ButtonInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Tool hinzufügen")
	return /** @type {LocalizedString} */ ("Add tool")
});